// Copyright TraderEvolution Global LTD. © 2017-2024. All rights reserved.

import { Resources } from "../../Commons/properties/Resources.ts";
import { LinkedSystem } from "../misc/LinkedSystem.js";
import { StatementItem } from "../cache/StatementItem.js";
import { ColouringModes } from "../elements/QuickTable/QuickTableColumn.js";
import { TerceraLabel } from "../elements/TerceraLabel.js";
import { ExportScreen } from "../screen/ExportScreen.js";
import { PanelNames } from "../UtilsClasses/FactoryConstants.ts";
import { ApplicationPanelNew } from "./ApplicationPanelNew.js";
import { RangeSelectPanel } from "./RangeSelectPanel.js";
import { GeneralSettings } from "../../Utils/GeneralSettings/GeneralSettings.ts";
import { AllowedReport } from "../../Commons/cache/AllowedReport.ts";
import { DataCache } from "../../Commons/DataCache.ts";
import { SessionSettings } from "../../Commons/SessionSettings.ts";
import { StatementPanelTemplate } from "../../templates.js";


export let StatementPanel = ApplicationPanelNew.extend(
    {
        partials: { bodyPartial: StatementPanelTemplate },
        data: function ()
        {
            return {
                isAccountLinkShow: true,
                isSymbolLinkShow: false,
                isDataExist: true
            };
        },
        headerLocaleKey: 'panel.statement',
        rangeSelectPanel: null,
        selectedStartTime: null,
        selectedFinishTime: null,
        displayAmountInLots: null
    });

StatementPanel.prototype.getType = function () { return PanelNames.StatementPanel };

StatementPanel.prototype.oncomplete = function ()
{
    ApplicationPanelNew.prototype.oncomplete.apply(this);

    this.addRangeSelectPanel();

    let noDataLabel = this.Controls.noDataLabel;
    noDataLabel.set({
        text: Resources.getResource('panel.statement.noData')
    });

    this.layoutTable();

    this.populateTableContextMenu();

    this.displayAmountInLots = GeneralSettings.View.displayAmountInLots();
    GeneralSettings.SettingsChanged.Subscribe(this.settingsChanged, this);
};

StatementPanel.prototype.addRangeSelectPanel = function ()
{
    var topPanel = this.Controls.statementPanelRangeSelect;

    topPanel.set({
        refreshBtnTT: 'panel.statement.searchBtn.tt'
    });
    topPanel.getReportEvent.Subscribe(this.getStatementReport, this)
    topPanel.on('refreshClick', this.refreshStatementReport.bind(this))
    topPanel.updateSelectedRange();
    this.rangeSelectPanel = topPanel;
};

StatementPanel.prototype.dispose = function ()
{
    this.getQuickTable().OnSelectionChanged.UnSubscribe(this.selectionChange, this);
    this.rangeSelectPanel.getReportEvent.UnSubscribe(this.getStatementReport, this)

    GeneralSettings.SettingsChanged.UnSubscribe(this.settingsChanged, this)

    ApplicationPanelNew.prototype.dispose.apply(this);
};

StatementPanel.prototype.layoutTable = function ()
{
    ApplicationPanelNew.prototype.layoutTable.apply(this);

    // let noDataLabel = this.noDataLabel
    // if (noDataLabel)
    // {
    //     let w = this.get('width'), h = this.get('height')
    //     this.noDataLabel.setBounds(0, 30, w, h);
    //     this.noDataLabel.set('style', 'line-height: ' + h + 'px')
    // }
}

StatementPanel.prototype.refreshStatementReport = function ()
{
    this.getStatementReport(this.selectedStartTime, this.selectedFinishTime)
}

StatementPanel.prototype.populateTableContextMenu = function ()
{
    var items = [];

    if (!Resources.isHidden('screen.export.visibility'))
        items.push(
            {
                text: Resources.getResource('screen.export.contextMenu'),
                event: ExportScreen.show.bind(null, this)
            }
        );

    if (!Resources.isHidden('panel.statement.print'))
        items.push(
            {
                text: Resources.getResource('screen.reports.print'),
                event: this.printTable.bind(this)
            }
        );

    if (!Resources.isHidden('contextMenu.Totals.visibility'))   // переделать в случае появления новых subitems
        items.push(
            {
                text: Resources.getResource('panel.positions.menu.View'),
                tag: 'View',
                enabled: true,
                subitems: [
                    {
                        text: Resources.getResource('panel.positions.menu.ShowTotals'),
                        tag: "ShowTotals",
                        checked: false,
                        enabled: true,
                        canCheck: true,
                        event: this.ShowTotalsStateChange.bind(this)
                    }
                ]
            }
        );

    items.push({ separator: true });
    this.getQuickTable().setTableContextMenuItems(items);
};

StatementPanel.prototype.getStatementReport = function (startTime, finishTime)
{
    let DC = DataCache,
        self = this

    self.selectedStartTime = startTime
    self.selectedFinishTime = finishTime

    self.set('loading', true)

    DC.StatementReportCompleted = false;
    DC.getReport(AllowedReport.REPORT_STATEMENT, startTime.toString(), finishTime.toString()).then(function (statements)
    {
        let qtRactive = self.quickTableRactive
        let qt = qtRactive ? qtRactive.quickTable : null
        if (!qt) return

        qt.ClearRows();
        let len = statements.length
        for (let i = 0; i < len; i++)
            qt.AddItem(new StatementItem(statements[i], SessionSettings))

        self.set({
            isDataExist: len ? true : false
        });

        let lS = LinkedSystem
        if (lS.accLinkingActive)        // отфильтруем по аккаунту если включена линковка
        {
            let accId = lS.accountStorage[Object.keys(lS.accountStorage)]
            qt.filterByAccountNumber(accId)
        }

    }).finally(function ()
    {
        self.set('loading', false)
    })
}

StatementPanel.prototype.settingsChanged = function ()
{
    let newSettingsInLots = GeneralSettings.View.displayAmountInLots()
    if (this.displayAmountInLots == newSettingsInLots)
        return

    this.displayAmountInLots = newSettingsInLots
    this.refreshStatementReport()
}

StatementPanel.prototype.SetColumnsColouringMode = function (table)
{
    this.ProcessSetColumnsColouringMode(table, [5], ColouringModes.Signed);
}